function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import styled from '@emotion/styled';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx } from '@emotion/core';
import ScrollBar from 'react-scrollbars-custom';
import Button from './Button';
import { CheckIcon } from '../icon';
import { check2, list, printStyle } from '../styles/wizard';
const WizardContext = /*#__PURE__*/React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'next':
      {
        const {
          currentIndex,
          currentPercentage,
          percentageToIncrease,
          steps
        } = state;

        if (currentIndex < steps.length - 1) {
          const newSteps = [...steps];
          const newStepIndex = currentIndex + 1;
          newSteps[currentIndex] = { ...newSteps[currentIndex],
            status: 'finished'
          };
          newSteps[newStepIndex] = { ...newSteps[newStepIndex],
            status: 'current'
          };
          return { ...state,
            steps: newSteps,
            currentIndex: newStepIndex,
            currentStepCode: steps[newStepIndex].code,
            currentPercentage: currentPercentage + percentageToIncrease,
            action: 'next',
            status: 'navigate'
          };
        }

        return state;
      }

    case 'beforeFinish':
      {
        const {
          currentIndex,
          steps
        } = state;
        const newSteps = [...steps];
        newSteps[currentIndex] = { ...newSteps[currentIndex],
          status: 'beforeFinished'
        };
        return { ...state,
          steps: newSteps,
          action: 'next',
          status: 'navigate'
        };
      }

    case 'back':
      {
        const {
          currentIndex,
          currentPercentage,
          percentageToIncrease,
          steps
        } = state;

        if (currentIndex > 0) {
          const newSteps = [...steps];
          const newStepIndex = currentIndex - 1;
          newSteps[currentIndex] = { ...newSteps[currentIndex],
            status: 'inactive'
          };
          newSteps[newStepIndex] = { ...newSteps[newStepIndex],
            status: 'current'
          };
          return { ...state,
            steps: newSteps,
            currentIndex: newStepIndex,
            currentStepCode: steps[newStepIndex].code,
            currentPercentage: currentPercentage - percentageToIncrease,
            action: 'back',
            status: 'navigate'
          };
        }

        return state;
      }

    case 'saveAndNavigate':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'executingPromise'
        };
      }

    case 'saveAndExit':
      {
        return { ...state,
          action: 'saveAndExit',
          status: 'executingPromise'
        };
      }

    case 'showModal':
      {
        return { ...state,
          action: 'showModal',
          status: 'executingPromise'
        };
      }

    case 'hideModal':
      {
        return { ...state,
          action: 'hideModal',
          status: 'executingPromise'
        };
      }

    case 'saveAndNavigatePending':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'isPendingSaveAndNavigate'
        };
      }

    case 'saveAndNavigateResolved':
      {
        return { ...state,
          action: 'saveAndNavigate',
          status: 'isResolvedSaveAndNavigate'
        };
      }

    case 'save':
      {
        return { ...state,
          action: 'save',
          status: 'executingPromise'
        };
      }

    case 'savePending':
      {
        return { ...state,
          action: 'save',
          status: 'isPendingSave'
        };
      }

    case 'saveResolved':
      {
        return { ...state,
          action: 'save',
          status: 'isResolvedSave'
        };
      }

    default:
      throw new Error('unexpected action type');
  }
};

function useWizard() {
  const context = React.useContext(WizardContext);

  if (context === undefined) {
    throw new Error('useWizard debe ser usado dentro de WizardProvider');
  }

  return context;
}

const Title = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 41px;
  color: #2b2d42;
  margin-top: 0px;
`;
const Subtitle = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: #0883a0;
  text-transform: uppercase;
`;
/**
 * This component represent the StepsSideBarHead
 * @param {string} title Wizard head title.
 * @param {string} subtitle Wizard head subtitle
 */

const StepsSideBarHead = /*#__PURE__*/React.memo(({
  title,
  subtitle
}) => {
  return jsx(React.Fragment, null, jsx(Subtitle, null, subtitle), jsx(Title, null, title));
});
/**
 * This component represent the Step Side Bar circle
 * @param {string} status Step status (current, finished, beforeFinished)
 */

const StepsSideBarListItemCircle = /*#__PURE__*/React.memo(({
  status
}) => {
  let style = {};

  switch (status) {
    case 'current':
      style = {
        backgroundColor: '#E95A5F',
        border: '2px solid #D33E43'
      };
      break;

    case 'finished':
    case 'beforeFinished':
      style = {
        backgroundColor: '#D33E43',
        border: '2px solid #D33E43'
      };
      break;

    default:
      break;
  }

  return jsx("div", {
    style: {
      width: 30,
      height: 30,
      backgroundColor: '#DFEFF2',
      border: '2px solid #0883A0',
      borderRadius: '50%',
      transition: '1.2s ease',
      ...style
    }
  }, status === 'finished' || status === 'beforeFinished' ? jsx(CheckIcon, {
    width: 16,
    height: 12,
    css: check2
  }) : null);
});
/**
 * This component represent the Step Side Bar item name
 * @param {string} children Item name.
 */

const StepsSideBarListItemName = /*#__PURE__*/React.memo(({
  children
}) => {
  return jsx("div", {
    style: {
      lineHeight: '30px',
      marginLeft: 24,
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 17,
      letterSpacing: '0.01em',
      color: '#D33E43'
    }
  }, children);
});
/**
 * This component represent the Step Side Bar item
 * @param {*} children Item name.
 * @param {JSON} status Custom style for the li.
 */

const StepsSideBarListItem = /*#__PURE__*/React.memo(({
  children,
  listItemStyle
}) => {
  return jsx("li", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      marginBottom: 40,
      ...listItemStyle
    }
  }, children);
});
/**
 * This component represent the Step Side Bar list
 * @param {JSON} listItemStyle Custom style for the  StepsSideBarListItem component.
 * @param {JSON} state Side bar list actual state.
 */

const StepsSideBarList = /*#__PURE__*/React.memo(({
  listItemStyle,
  state
}) => {
  return jsx("ul", {
    css: list(state.currentPercentage)
  }, state.steps.map(step => jsx(StepsSideBarListItem, {
    key: step.id,
    listItemStyle: listItemStyle
  }, jsx(StepsSideBarListItemCircle, {
    status: step.status
  }), jsx(StepsSideBarListItemName, null, step.name))));
}, (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps));
/**
 * This component represent the Step Side Bar container for the side bar list.
 * @param {*} children Content of the side bar.
 * @param {JSON} containerStyle Custom style for the  container.
 */

const StepsSideBarContainer = /*#__PURE__*/React.memo(function StepsSideBarContainer({
  children,
  containerStyle
}) {
  return jsx("div", {
    className: "no-print",
    style: {
      backgroundColor: '#E9F1F2',
      width: '40%',
      position: 'relative',
      padding: 40,
      boxSizing: 'border-box',
      ...containerStyle
    }
  }, children);
});
/**
 * This component represents the steps of the sidebar.
 * @param {JSON} containerStyle Custom style for the container.
 * @param {*} children Steps of the sidebar.
 * @param {*} alternativeControl Other step for the side bar container.
 * @param {JSON} listItemStyle Used to display the language selector.
 * @param {string} title  StepsSideBarHead title.
 * @param {string} subtitle StepsSideBarHead subtitle.
 */

const StepsSideBar = /*#__PURE__*/React.memo(({
  containerStyle,
  children,
  alternativeControl,
  listItemStyle,
  title,
  subtitle
}) => {
  const [{
    steps,
    currentPercentage
  }] = useWizard();
  return jsx(StepsSideBarContainer, {
    containerStyle: containerStyle
  }, jsx("div", {
    style: {
      paddingLeft: 30,
      paddingBottom: 15
    }
  }, children, jsx(StepsSideBarHead, {
    title: title,
    subtitle: subtitle
  }), jsx(StepsSideBarList, {
    listItemStyle: listItemStyle,
    state: {
      steps,
      currentPercentage
    }
  })), alternativeControl);
});
/**
 * This component represent.
 * @param {*} children Step content.
 * @param {string} name Step name.
 */

function StepComponent({
  children,
  name
}) {
  const [{
    steps
  }] = useWizard();
  const i = steps.findIndex(({
    name: stepName,
    status
  }) => stepName === name && (status === 'current' || status === 'beforeFinished'));

  if (i < 0) {
    return null;
  }

  return jsx("div", {
    style: {
      padding: 4
    }
  }, children);
}

StepComponent.displayName = 'Step';
/**
 * This component represent the steps of the sidebar.
 * @param {*} children Step content.
 * @param {JSON} scrollStyle Custom scroll style for the wizard steps.
 */

function StepsContent({
  children,
  scrollStyle
}) {
  return jsx("div", {
    key: "content",
    style: {
      padding: '80px 10px 0 80px',
      width: '100%'
    }
  }, jsx(ScrollBar, {
    style: {
      width: '100%',
      height: '100%',
      minHeight: 'calc(100vh - 164px)',
      padding: 2,
      boxSizing: 'border-box',
      ...scrollStyle
    },
    scrollTop: 0,
    trackYProps: {
      renderer: props => {
        const {
          elementRef,
          style,
          ...restProps
        } = props;
        return jsx("span", _extends({}, restProps, {
          style: { ...style,
            backgroundColor: '#e9f1f2'
          },
          ref: elementRef
        }));
      }
    },
    thumbYProps: {
      renderer: props => {
        const {
          elementRef,
          ...restProps
        } = props;
        return jsx("div", _extends({}, restProps, {
          style: {
            backgroundColor: '#0883A0'
          },
          ref: elementRef
        }));
      }
    }
  }, children));
}

StepsContent.displayName = 'StepsContent';
/**
 * This component represent the next button on wizard.
 * @param {*} children Button content.
 * @param {function} onClick Triggered when click o next button.
 * @param {*} props All other supported props.
 */

function StepButtonNext({
  children,
  onClick,
  ...props
}) {
  const [{
    steps,
    currentIndex
  }, dispatch] = useWizard();
  const disabled = steps.length === currentIndex + 1;
  return jsx(Button, _extends({
    color: "fireEngineRed",
    outline: true
  }, props, {
    onClick: () => dispatch({
      type: 'next'
    }),
    disabled: disabled
  }), children);
}
/**
 * This component represent the back button on wizard.
 * @param {*} children Button content.
 * @param {function} onClick Triggered when click o back button.
 * @param {*} props All other supported props.
 */


function StepButtonBack({
  children,
  onClick,
  ...props
}) {
  const [{
    currentIndex
  }, dispatch] = useWizard();
  const disabled = currentIndex === 0;
  return jsx(Button, _extends({
    outline: true
  }, props, {
    onClick: () => dispatch({
      type: 'back'
    }),
    disabled: disabled
  }), children);
}
/**
 * This component represents the wizard provider 2.
 * @param {*} children Wizard content.
 * @param {number} currentStep Current wizard step, default 0.
 * @param {JSON} containerStyle Custom container style for the wizard.
 * @param {JSON} css Custom style for provider.
 * @param {*} props All other supported props.
 */


function WizardProvider2({
  children,
  currentStep = 0,
  containerStyle,
  css,
  ...props
}) {
  const memoizedSteps = React.useMemo(() => {
    const [steps] = React.Children.toArray(children).filter(child => child.type.displayName === 'StepsContent').map(child => {
      return React.Children.toArray(child.props.children).filter(({
        type
      }) => type.type.displayName === 'Step').map((step, index) => {
        var _step$props$code, _step$props;

        let status = 'inactive';

        if (index === currentStep) {
          status = 'current';
        } else if (index < currentStep) {
          status = 'finished';
        }

        return {
          id: index,
          order: index,
          code: (_step$props$code = (_step$props = step.props) === null || _step$props === void 0 ? void 0 : _step$props.code) !== null && _step$props$code !== void 0 ? _step$props$code : null,
          name: step.props.name,
          status
        };
      });
    });
    return steps;
  }, []);
  const value = React.useReducer(reducer, {
    currentIndex: currentStep,
    currentStepCode: memoizedSteps[currentStep].code,
    currentPercentage: currentStep * (100 / (memoizedSteps.length - 1)),
    percentageToIncrease: 100 / (memoizedSteps.length - 1),
    steps: memoizedSteps,
    action: 'initialize',
    status: 'initial'
  }); // React.useEffect(() => {
  //   const [steps] = React.Children.toArray(children)
  //     .filter(
  //       child =>
  //         console.count('calculando steps') ||
  //         child.type.displayName === 'StepsContent'
  //     )
  //     .map(child => {
  //       return React.Children.toArray(child.props.children)
  //         .filter(({ type }) => type.type.displayName === 'Step')
  //         .map((step, index) => ({
  //           id: index,
  //           order: index,
  //           name: step.props.name,
  //           status: index === 0 ? 'current' : 'inactive',
  //         }))
  //     })
  //   setState(values => ({
  //     ...values,
  //     percentage: 100 / (steps.length - 1),
  //     steps,
  //   }))
  // }, [])
  // React.useEffect(() => {
  //   setState(values => ({
  //     ...values,
  //     title,
  //   }))
  // }, [title])
  // React.useEffect(() => {
  //   setState(values => ({
  //     ...values,
  //     subtitle,
  //   }))
  // }, [subtitle])
  // function back() {
  //   const {
  //     backIndex,
  //     current: currentIndex,
  //     currentPercentage,
  //     percentage,
  //   } = state
  //   if (currentIndex > 0) {
  //     const newArr = [...state.steps]
  //     newArr[currentIndex] = {
  //       ...newArr[currentIndex],
  //       status: 'inactive',
  //     }
  //     newArr[backIndex] = {
  //       ...newArr[backIndex],
  //       status: 'current',
  //     }
  //     setState(values => ({
  //       ...values,
  //       steps: newArr,
  //       current: backIndex,
  //       nextIndex: currentIndex,
  //       backIndex: backIndex - 1 < 0 ? 0 : backIndex - 1,
  //       currentPercentage: currentPercentage - percentage,
  //     }))
  //   }
  // }
  // console.count('Render Wizard')

  return jsx(WizardContext.Provider, {
    value: value
  }, jsx("div", _extends({
    style: {
      display: 'flex',
      flexDirection: 'row',
      ...containerStyle
    }
  }, props, {
    css: [css, printStyle]
  }), children));
}

const Step = /*#__PURE__*/React.memo(StepComponent);
const WizardProvider = /*#__PURE__*/React.memo(WizardProvider2); // const StepsSideBar = React.memo(
//   StepsSideBarComponent,
//   (prevProps, nextProps) => {
//     return false
//   }
// )

export { WizardProvider, useWizard, Step, StepButtonNext, StepButtonBack, StepsSideBar, StepsContent };